import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { PupAvatar } from '../../components';
import { Section, SectionTitle as SummaryItemTitle } from './styles';

const StyledSummaryItem = styled(Section)`
  align-items: center;

  @media ${({ theme }) => theme.tablet} {
    align-items: none;
  }

  > div:first-of-type {
    margin-bottom: ${({ theme }) => theme.spacing(3)};

    @media ${({ theme }) => theme.tablet} {
      margin-right: ${props => props.theme.spacing(6)};
    }
  }
`;

const OrderInfoGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
`;

const OrderInfoList = styled.div`
  flex-grow: 1;
`;

const OrderPricing = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.tablet} {
    flex-direction: row;
  }
`;

const Price = styled.div`
  ${props => props.theme.typography.heading4}
  ${({ strikethrough }) =>
    strikethrough
      ? css`
          text-decoration: line-through;
          color: ${({ theme }) => theme.colors.text.tertiary};
          opacity: 0.75;
          margin-right: 0;

          @media ${({ theme }) => theme.tablet} {
            margin-right: ${({ theme }) => theme.spacing(3)};
          }
        `
      : css`
          font-weight: bold;
          color: ${({ theme }) => theme.colors.text.secondary};
        `}
  @media ${({ theme }) => theme.tablet} {
    ${({ theme }) => theme.typography.heading4}
  }
`;

const ListItemsContainer = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const StyledLi = styled.li`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const SummaryItem = ({
  breeds,
  price,
  discountedPrice,
  pricePerWeek,
  recipe,
  backgroundColor,
  title,
  summaryList,
}) => {
  return (
    <StyledSummaryItem columns={3}>
      <PupAvatar
        {...{
          breeds,
          color: backgroundColor,
          variant: 'circle',
          fullBleed: true,
        }}
      />
      <OrderInfoGroup>
        <OrderInfoList>
          <SummaryItemTitle>{title}</SummaryItemTitle>
          <ListItemsContainer>
            {summaryList?.map(({ label, content }, index) => {
              // temp solution to remove 'Next Delivery' for Recurring Subscription Box (as BE does not pass correct date)
              // All we must do to revert is remove the below check (if/else) statement and use the default return
              if (label === 'Next Delivery') {
                return null;
              } else {
                return (
                  <StyledLi key={index}>
                    <strong>{label}: </strong>
                    {content}
                  </StyledLi>
                );
              }
            })}
          </ListItemsContainer>
        </OrderInfoList>
        <OrderPricing>
          <Price strikethrough>{price}</Price>
          <Price>{discountedPrice}</Price>
          {pricePerWeek && <Price>{pricePerWeek}/week</Price>}
        </OrderPricing>
      </OrderInfoGroup>
    </StyledSummaryItem>
  );
};

SummaryItem.displayName = 'SummaryItem';
SummaryItem.propTypes = {
  breeds: PropTypes.arrayOf(PropTypes.string.isRequired),
  price: PropTypes.string,
  discountedPrice: PropTypes.string,
  pricePerWeek: PropTypes.string,
  recipe: PropTypes.shape({
    fresh: PropTypes.arrayOf(PropTypes.string),
    baked: PropTypes.arrayOf(PropTypes.string),
  }),
  backgroundColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  summaryList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
